import React from "react";

function Contact() {
  return (
    <div>
      <section className="ftco-section">
        <div className="container">
          <div className="row">
            <div className="col-md-4"></div>
            <div className="col-md-4 heading-section ftco-animate fadeInUp ftco-animated">
              <h2 style={{color:"#3A3A3A"}}><b><center>Contact us</center></b></h2>
            </div>
            <div className="col-md-4"></div>
          </div>
          <div className="row" style={{marginBottom:"150px"}}>
            <div className="col-md-4"></div>
            <div className="col-md-4 heading-section ftco-animate fadeInUp ftco-animated">
              <div style={{backgroundColor: "#5E5550",color: "#ffffff",borderRadius: "8px",alignItems:"center",paddingTop:"7px",paddingBottom:"7px"}}>
                <center>Nabeel Saeed Law Firm </center>
                <center>Attorneys at Law & Legal Consultants</center>
                <center>PO Box 28884</center>
                <center>Manama</center>
                <center>Kingdom of Bahrain</center>
                <center>Tel: 00973 17 530036</center>
                <center>Fax: 00973 17 530037</center>
                <center>Email: nabeel@nabeelsaeed.com</center>
              </div>
            </div>
            <div className="col-md-4"></div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Contact;
